import { render, staticRenderFns } from "./ctc.vue?vue&type=template&id=22942a64&"
import script from "./ctc.vue?vue&type=script&lang=js&"
export * from "./ctc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports